import { createOrderBuildSession } from './OrderBuildSession';
import { buildOrderLineTreeG6 } from './OrderLineTreeBuilderG6';
import { runOrderPricingPipelineG6 } from './OrderPricingPipelineG6';
import { ApmHelper, ApmSpanType } from '../libraries/ApmHelper';
const hasHeatableProduct = (productCatalog, selections, includeDisabledProducts = false) => {
    for (const i in selections) {
        const selection = selections[i];
        const product = productCatalog.getProduct(selection.productId, includeDisabledProducts);
        if (product && product.heatable) {
            return true;
        }
    }
    return false;
};
const mapToOrderLinesG6Impl = (productCatalog, productSelection, includeHeatBoxes = false, options = {}, orderTags = []) => {
    if (!productCatalog || !productCatalog.products || !productCatalog.products.length) {
        return [];
    }
    const session = createOrderBuildSession({
        cartProductsMap: options === null || options === void 0 ? void 0 : options.cartProductsMap,
        exceededPriceRules: options === null || options === void 0 ? void 0 : options.exceededPriceRules,
    });
    const orderLines = buildOrderLineTreeG6({
        productCatalog,
        productSelection,
        options,
        session,
    });
    const addHeatBox = (includeHeatBoxes && hasHeatableProduct(productCatalog, productSelection, !!options.includeDisabledProducts)) ||
        (includeHeatBoxes && !!options.isAdmin);
    return runOrderPricingPipelineG6({
        productCatalog,
        orderLines,
        options,
        orderTags,
        session,
        addHeatBox,
    });
};
export const mapToOrderLinesG6 = ApmHelper.apmDecorator(mapToOrderLinesG6Impl, {
    apmLabel: 'OrderLineMappingsG6',
    apmType: ApmSpanType.PURE_FUNCTION,
});
export default mapToOrderLinesG6;
